import React from 'react'
import styled from 'styled-components'
import { Filters, ProdutosList, Sort, PageHero } from '../components'

const ProdutosPage = () => {
  return (
    <main>
      <PageHero title='produtos' />
      <Wrapper className='page'>
        <div className='section-center produtos'>
          <Filters />
          <div>
            <Sort />
            
            <ProdutosList />
          </div>
        </div>
      </Wrapper>
    </main>
  )
}

const Wrapper = styled.div`
  .produtos {
    display: grid;
    gap: 3rem 1.5rem;
    margin: 4rem auto;
  }
  @media (min-width: 768px) {
    .produtos {
      grid-template-columns: 200px 1fr;
    }
  }
`

export default ProdutosPage
